import styled from 'styled-components';

export const StyledMinutesList = styled.ul`
    padding: 100px 0;
    list-style-type: none;
    a:first-of-type {
        font-size: 1.7rem;
    }

    a {
        display: block;
    }

    #schedule {
        color: #af0808
    }
`
